import { Helmet } from 'react-helmet-async';
import PageTitle from 'src/components/PageTitle';
import { useState } from 'react';


import PageTitleWrapper from 'src/components/PageTitleWrapper';
import {
    Container,
    Grid,
    Card,
    CardHeader,
    CardContent,
    Divider,
    ImageList,
    ImageListItem,
    Typography,
    IconButton,
    Tooltip
} from '@mui/material';
import Footer from 'src/components/Footer';

import Box from '@mui/material/Box';

import { useNavigate, useParams } from 'react-router-dom';
import useToast from '../../../../hooks/useToast';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useApi } from '../../../../hooks/useApi';
import Button from '../../../../components/Core/Button/Button';
import { IFile, IReportedDetails } from '../../../../interfaces';
import { getFileById } from '../../../../services/FileService';
import { getReportById, reportContent } from '../../../../services/ReportService';
import SelectCtrl from '../../../../controllers/SelectCtrl';
import Loader from '../../../../components/Core/Loader';
import { dateFormat } from "../../../../utils";
import { useMutation } from '../../../../hooks/useMutation';
import { deleteReport, getAllReport } from "../../../../services/ReportService";
import DeleteConfirm from 'src/components/Core/InplaceConfirm/DeleteConfirm';
import { deleteUser } from 'src/services/UserService';


const defaultValues: IReportedDetails = {
    Id: 0,
    ReportedBy: 0,
    ReportedUser: 0,
    Reason: '',
    ParentId: '',
    SystemObjectId: 0,
    SystemObjectRecordId: '',
    AddedOn: '',
    ModifiedOn: '',
    SystemObjectName: '',
    ReportedByName: '',
    ReportedUserName: '',
    isReport: '',
    Message: ''
};

const ReportedMessageDetails = () => {
    const params = useParams();
    const navigate = useNavigate();
    const { showToast, dissmisToast } = useToast();


    const {
        control,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm<IReportedDetails>({
        defaultValues: {
            ...defaultValues
        },
        mode: 'onBlur'
    });

    const {
        data: reportDetails = {
            ...defaultValues
        },
        isLoading: isFetchingReportContentDetails,
        errorMessage
        // reCall: refetchFaqDetails
    } = useApi('ReportContentDetails', () => getReportById(params.id), {
        enabled: params.id && params.id !== 'new',
        onSuccess: (response) => {
            const tempData = response.data;
            reset({
                ...tempData,
                Date: tempData.AddedOn ? dateFormat(tempData.AddedOn) : ''
            });
            return tempData;
        },
        onError: (error) => {
            showToast('error', error.message);
        }
    });

    const showError = (_fieldName: string): any => {
        const keyList: Array<string> = _fieldName.split('.');
        const [key1, key2] = keyList;
        let error;
        if (key1 && key2) {
            const errorObj = (errors as any)[key1];
            error = errorObj ? errorObj[key2] : null;
        } else if (key1) {
            error = (errors as any)[key1];
        }
        return error ? error.message || 'Field is required' : null;
    };

    const onSubmit: SubmitHandler<IReportedDetails> = async (data) => {
        const key = 'SaveFaq';
        try {
            showToast('info', 'Your request is being processed', key);
            const { } = data;
            const saveRes = await reportContent(
                reportDetails.Id,
                data.isReport === 'Accept' ? true : false
            );
            dissmisToast(key);
            if (saveRes.status === 200) {
                showToast('success', saveRes.message);
                navigate(-1);
            } else {
                throw saveRes.error;
            }
        } catch (error) {
            dissmisToast(key);
            showToast('error', error.message ? error.message : error);
        }
    };

    const deleteUserTostyKey = 'ReportDelete';
    const { isLoading: isDeleteing, mutate: reportDelete } = useMutation(
        'ReportDelete',
        () => deleteReport(reportDetails.Id),
        {
            enabled: false,
            onFire: () => {
                showToast(
                    'info',
                    'Your request is being processed',
                    deleteUserTostyKey
                );
            },
            onSuccess: (response) => {
                dissmisToast(deleteUserTostyKey);
                showToast('success', response.message || 'Successful');
                navigate(-1);
                return response;
            },
            onError: (error: Error) => {
                dissmisToast(deleteUserTostyKey);
                showToast('error', error.message);
            }
        }
    );

    return (
        <>
            <Helmet>
                <title>Reported Message Details</title>
            </Helmet>
            <PageTitleWrapper>
                <PageTitle heading="Reported Message Details" />
            </PageTitleWrapper>
            <Container maxWidth="lg">
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="stretch"
                    spacing={3}
                >
                    <Grid item xs={12}>
                        <Card>
                            <Divider />
                            <CardContent>
                                {isFetchingReportContentDetails ? (
                                    <Loader isShow={isFetchingReportContentDetails} />
                                ) : errorMessage ? <div>{errorMessage}</div> : (
                                    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                                        <Grid container spacing={2}>
                                            <Grid item xs={4}>
                                                <Typography variant="subtitle1">REPORTED BY</Typography>
                                                <Typography variant="subtitle2" color="black">
                                                    {reportDetails.ReportedByName}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Typography variant="subtitle1">
                                                    REPORTED USER
                                                </Typography>
                                                <Typography variant="subtitle2" color="black">
                                                    {reportDetails.ReportedUserName}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Typography variant="subtitle1">DATE</Typography>
                                                <Typography variant="subtitle2" color="black">
                                                    {dateFormat(reportDetails.AddedOn)}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <SelectCtrl
                                                    control={control}
                                                    label="Action"
                                                    name="isReport"
                                                    showError={showError}
                                                    placeholder="--Please Select--"
                                                    required={true}
                                                    disabled={isFetchingReportContentDetails}
                                                    options={[
                                                        {
                                                            label: 'Pending',
                                                            value: 'Pending'
                                                        },
                                                        {
                                                            label: 'Accepted',
                                                            value: 'Accepted'
                                                        },
                                                        {
                                                            label: 'Declined',
                                                            value: 'Declined'
                                                        }
                                                    ]}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Typography variant="subtitle1">REASON</Typography>
                                                <Typography variant="subtitle2" color="black">
                                                    {reportDetails.Reason}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Typography variant="subtitle1">DETAILS</Typography>
                                                <Typography variant="subtitle2" color="black">
                                                    {reportDetails.Message}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item xs={1}>
                                                <Button label="Submit" type="submit" size="small" />
                                            </Grid>
                                            <Grid item xs={1}>
                                                <Button
                                                    label="Cancel"
                                                    type="button"
                                                    variant="outlined"
                                                    size="small"
                                                    btnFor="cancel"
                                                    onClick={() => navigate(-1)}
                                                />
                                            </Grid>
                                            <Grid item xs={10} textAlign="end">
                                                <DeleteConfirm
                                                    isHide={!reportDetails.Id}
                                                    confirm={reportDelete}
                                                    disabled={isDeleteing}
                                                />
                                            </Grid>
                                        </Grid>
                                    </form>
                                )}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
            <Footer />
        </>
    );
};

export default ReportedMessageDetails;
function fetchPosts() {
    throw new Error('Function not implemented.');
}

function showToast(arg0: string, arg1: string, deleteReportKey: string) {
    throw new Error('Function not implemented.');
}

function dissmisToast(deleteReportKey: string) {
    throw new Error('Function not implemented.');
}

function row(row: any, IReportedDetails: any) {
    throw new Error('Function not implemented.');
}

function onDelete(): any {
    throw new Error('Function not implemented.');
}

